module.exports = __webpack_public_path__ + "static/media/foodprint@2x.7f7333c6.jpg";